<template>
  <div class="wt2-sg -top-bar-inner">
    <div class="-button-container">
      <wt-button
        v-if="!hideCropButton"
        class="js-disable-to-reset"
        text="Crop"
        @click="crop"
        type="hollow-dark"
        icon="wticon-Crop"
      ></wt-button>
      <wt-button
        v-if="selectedLayout.canSwitchMainAndOverlay"
        class="js-disable-to-reset"
        text="Swap"
        @click="swapMedia"
        type="hollow-dark"
        icon="wticon-Swap"
        :active="selectedLayout.switchMainAndOverlay"
      >
      </wt-button>
    </div>
  </div>
</template>

<script>
import bus from 'v/AssetEditor/AssetEditorEventBus';
import openCrop from 'components/modals/types/cropping/wtCropping.modal';
import { mapActions, mapGetters } from 'vuex';

function canCrop(asset) {
  return (
    !app.assetType.isMAP(asset) &&
    (app.assetType.isIMAGE(asset) ||
      app.assetType.isGIF(asset) ||
      app.assetType.isFRAGMENT(asset) ||
      app.assetType.isSOCIALFRAGMENT(asset) ||
      app.assetType.isSOCIALIMAGE(asset))
  );
}

export default {
  props: ['stageRect'],

  computed: {
    ...mapGetters('assetEditor', [
      'selectedLayout',
      'selectedOverlayAsset',
      'workModel',
    ]),

    canCropMain() {
      return canCrop(this.workModel) && this.selectedLayout.id !== 'FULL_FRAME';
    },

    canCropOverlay() {
      return canCrop(this.selectedOverlayAsset);
    },

    hideCropButton() {
      return !this.canCropMain && !this.canCropOverlay;
    },
  },

  methods: {
    ...mapActions('assetEditor', ['setCropData', 'swapMediaOnOverlayAsset']),

    swapMedia() {
      app.analytics('analytics.scenes.clickedSwap', {
        layout: this.selectedLayout.category,
      });
      this.swapMediaOnOverlayAsset();
      bus.$emit('refreshOverlayRCP');
    },

    crop() {
      let selectedAsset = 'overlay';
      if (!this.canCropOverlay) {
        selectedAsset = 'main';
      }
      app.analytics('analytics.scenes.clickedCrop', { from: 'layout' });
      openCrop({
        main: _.cloneDeep(this.workModel),
        overlay: _.cloneDeep(this.selectedOverlayAsset),
        offset: this.stageRect,
        currentTime: 0,
        selectedAsset,
      }).$on('close', (e, o) => {
        if (!_.isEmpty(o)) {
          this.setCropData(o);
          bus.$emit('refreshOverlayRCP');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.-top-bar-inner {
  padding-bottom: 30px;
  position: relative;
}

.-button-container {
  font-size: 0;
  button {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 30px;
  z-index: 1;
}
</style>
